import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import {
  buildSearchQuery,
  comboboxValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { InputObject } from "../controls/default";

export interface CategoriesForm {
  readonly uid?: string;
  readonly rowVersion?: string;
  readonly name: string;
  readonly code: string;
  readonly description: string;
  readonly contentType: InputObject;
}

export const categoriesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Code",
    key: "code",
    width: 192,
    sort: true,
  },
  {
    title: "Description",
    key: "description",
    width: 320,
    sort: true,
  },
  {
    title: "Content Type",
    key: "contentType",
    width: 160,
    sort: true,
  },
  {
    title: "Templates",
    key: "templatesCount",
    width: 120,
    sort: true,
    type: "badge",
  },
  {
    title: "Created On",
    key: "createdOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
  {
    title: "Updated On",
    key: "updatedOn",
    width: 168,
    sort: true,
    format: "DD/MM/YYYY HH:mm",
  },
];

const categoriesQueryMappings: QueryFieldMapping[] = [
  { formField: "name", operation: QueryOperation.StartsWith },
  { formField: "code", operation: QueryOperation.StartsWith },
  { formField: "description", operation: QueryOperation.StartsWith },
  { formField: "contentType", operation: QueryOperation.Equal, transform: comboboxValue },
];

export const mapCategoriesViewQuery = (values: CategoriesForm): SearchQuery =>
  buildSearchQuery(values, categoriesQueryMappings);
